import ArrowDownShape from "@themuse/design-system/lib/components/Icons/ArrowDownShape";
import SquareButton from "@themuse/design-system/lib/components/Buttons/SquareButton";
import styles from "./LoadMore.module.scss";

interface ILoadMore {
    cb: () => void
}

/**
 * Renders the load more button if there are in fact more results to get.
 */
const LoadMore = (params: ILoadMore) => {
    const { cb } = params;
    return (
        <SquareButton
            className={styles.loadMore}
            color="secondary-100"
            onClick={cb}
        >
            Load More Results
            <ArrowDownShape />
        </SquareButton>
    );
};

LoadMore.displayName = "LoadMore";
export { LoadMore };
